import moment from "moment";
import React, {memo} from "react";
import {ReactComponent as Logo} from "../../../assets/newImages/header/logotipo.svg";
import ImgWithLoading from "../../../components/ImgWithLoading/ImgWithLoading";
import {Relatorio} from "../../../types/Relatorios";
import "./styles";
import {ContainerPrintableRelatorio} from "./styles";

interface PrintableRelatorioProps {
    relatorio: Relatorio;
    table: React.ReactElement;
}

const PrintableRelatorio: React.ForwardRefRenderFunction<
    HTMLTableElement,
    PrintableRelatorioProps
> = ({table, relatorio}, ref) => {
    return (
        <ContainerPrintableRelatorio ref={ref}>
            <div className="flex-container">
                <Logo className="print-logo"/>
                <div className="data">
                    Data: {moment().format("DD/MM/YYYY HH:mm:ss")}
                </div>
            </div>
            <div className="flex-center-align">
                <div className="titulo">{relatorio.nome}</div>
                <div className="descricao">{relatorio.descricao}</div>
            </div>
            {table}
        </ContainerPrintableRelatorio>
    );
};

export default memo(React.forwardRef(PrintableRelatorio));
